import React from 'react';
import { productImages, steps } from '../data/content';
export function HowItWorks() {
  return <section id="como-funciona" className="bg-night-panel" data-id="element-102" data-mp="7teq5h35ft0r">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-103" data-mp="7qiopis3em7k">
        <div className="mx-auto max-w-2xl text-center" data-id="element-104" data-mp="3q02rqwyzpy1o">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "36px"
        }} data-id="element-105" data-mp="3tzjz5vxz959h">
            Cómo funciona tu Botiquín
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-106" data-mp="qjmkpass9b5c">
            Cinco pasos simples, unos pocos minutos. Siempre que lo necesites.
          </p>
        </div>

        <img src={productImages.howItWorks} alt={productImages.howItWorksAlt} className="mx-auto mt-10 h-auto w-full max-w-2xl drop-shadow-[0_24px_40px_rgba(0,0,0,0.5)]" data-id="element-107" data-mp="gt1o1swo6gp2" />

        <ol className="relative mx-auto mt-12 grid max-w-md gap-8 lg:max-w-none lg:grid-cols-5 lg:gap-6" data-id="element-108" data-mp="19a49j4ahvmlf">
          <span aria-hidden="true" className="absolute bottom-6 left-6 top-6 w-px bg-gold-soft/30 lg:bottom-auto lg:left-[10%] lg:right-[10%] lg:top-6 lg:h-px lg:w-auto" data-id="element-109" data-mp="2rmpk8dit2vuw" />
          {steps.map((step, index) => <li key={step.title} className="relative flex gap-5 lg:flex-col lg:items-center lg:gap-0 lg:text-center" data-id="element-110" data-mp="31daj822e62ec" data-mpi={index}>
              <span className="relative flex h-12 w-12 flex-none items-center justify-center rounded-full border border-gold-soft/60 bg-night font-display text-lg font-semibold text-gold-soft" data-id="element-111" data-mp="3aaujb7oipsnd">
                {index + 1}
              </span>
              <div className="pt-1.5 lg:pt-5" data-id="element-112" data-mp="3k7z6nau3nu5r">
                <h3 className="font-display text-xl font-semibold uppercase leading-snug tracking-tight text-parchment" data-id="element-113" data-mp="3fca36weylt46">
                  {step.title}
                </h3>
                <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-114" data-mp="1kxr2mzdz9zos">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}